import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.91412 18.0273H3V6h1.91412v4.9999h5.19768V6h1.9141v12.0273h-1.9141v-5.0687H4.91412v5.0687zM22 14.4131c0 2.1808-1.5004 3.753-3.7131 3.753-1.8489 0-3.1674-.8622-4.0616-2.0794l1.3034-1.3524c.7577.9974 1.6064 1.5553 2.7885 1.5553 1.0458 0 1.8338-.7101 1.8338-1.792v-.0338c0-1.1665-.9547-1.8258-2.44-1.8258h-.8638l-.3031-1.3017 2.8643-3.39801h-4.592V6.12941h7.0169v1.5553L18.878 11.0658c1.6065.2198 3.122 1.1327 3.122 3.3134v.0339z",
    fill: "currentColor"
  }));
});